export default function BgAnim() {
  return (
    <div className="bg-anim-shape">
      <div className="bg-visuals">
        {/* Shape 1 */}
        <svg
          className="bg-shape shape-1"
          viewBox="0 0 1775 1121"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="1" filter="url(#filter0_f_7408_3)">
            <path
              d="M792.3 290.457C649.614 -7.16185 34.8997 529.564 243.768 519.164C534.798 197.956 1350.89 104.379 997.8 580.814C1311.3 858.456 1330.3 853.956 1574.41 920.57C1392.04 879.278 1219.07 1017.35 980.298 580.814C1061.28 476.956 879.3 328.457 792.3 290.457Z"
              fill="url(#paint0_radial_7408_3)"
            />
          </g>
          <defs>
            <filter
              id="filter0_f_7408_3"
              x="0.899"
              y="0.456"
              width="1773.51"
              height="1120.11"
              filterUnits="userSpaceOnUse"
            >
              <feGaussianBlur stdDeviation="100" />
            </filter>
            <radialGradient
              id="paint0_radial_7408_3"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(1155.42 986) rotate(-92.7605) scale(762.499 485.467)"
            >
              <stop stopColor="#018C8A" />
              <stop offset="0.410566" stopColor="#FFE99C" />
              <stop offset="0.666121" stopColor="#FFD345" />
              <stop offset="1" stopColor="#EB7949" />
            </radialGradient>
          </defs>
        </svg>

        {/* Shape 2 */}
        <svg
          className="bg-shape shape-2"
          viewBox="0 0 757 929"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="1" filter="url(#filter0_f_7408_5)">
            <path
              d="M409.333 469.601C241.186 140.993 344.999 193.956 443.842 222.365C560.494 328.379 109.327 325.978 217.584 527.91C338.328 720.659 646.072 521.201 531.452 563.748C407.264 701.559 675.921 892.387 409.333 469.601Z"
              fill="url(#paint0_radial_7408_5)"
            />
          </g>
          <defs>
            <filter
              id="filter0_f_7408_5"
              x="0.663"
              y="0.812"
              width="755.921"
              height="927.6"
              filterUnits="userSpaceOnUse"
            >
              <feGaussianBlur stdDeviation="100" />
            </filter>
            <radialGradient
              id="paint0_radial_7408_5"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(262.67 665.236) rotate(-121.59) scale(841.984 904.534)"
            >
              <stop stopColor="#018C8A" />
              <stop offset="0.410566" stopColor="#FFE99C" />
              <stop offset="0.666121" stopColor="#FFD345" />
              <stop offset="1" stopColor="#EB7949" />
            </radialGradient>
          </defs>
        </svg>

        {/* Shape 3 */}
        <svg
          className="bg-shape shape-3"
          viewBox="0 0 1150 1092"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="1" filter="url(#filter0_f_7408_4)">
            <path
              d="M775.811 707.499C502.162 952.106 176.629 903.82 202.17 838.327C291.847 726.588 651.148 933.556 819.417 780.65C980.423 625.54 707.904 162.562 740.289 202.633C850.701 202.466 1129.01 366.357 775.811 707.499Z"
              fill="url(#paint0_radial_7408_4)"
            />
          </g>
          <defs>
            <filter
              id="filter0_f_7408_4"
              x="0.756"
              y="0.185"
              width="1148.29"
              height="1091.16"
              filterUnits="userSpaceOnUse"
            >
              <feGaussianBlur stdDeviation="100" />
            </filter>
            <radialGradient
              id="paint0_radial_7408_4"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(933.214 691.674) rotate(136.275) scale(828.761 387.252)"
            >
              <stop stopColor="#018C8A" />
              <stop offset="0.410566" stopColor="#FFE99C" />
              <stop offset="0.666121" stopColor="#FFD345" />
              <stop offset="1" stopColor="#EB7949" />
            </radialGradient>
          </defs>
        </svg>
      </div>
    </div>
  );
}
